<div class="strength">
  <ul class="strengthBar mt-2">
    <li class="point" [style.background-color]="bar0"></li>
    <li class="point" [style.background-color]="bar1"></li>
    <li class="point" [style.background-color]="bar2"></li>
    <li class="point" [style.background-color]="bar3"></li>
    <li class="point" [style.background-color]="bar4"></li>
  </ul>

  @if (passwordToCheck?.length) {
    <p class="text-center mb-0" [style.color]="messageColor">{{ message }}</p>
  }
</div>
<div>
  @if (passwordToCheck?.length) {
    <ul class="no-bullets">
      <li>@if (!lengthMet) {
        <span><i class="pi pi-times"></i></span>
        }@if (lengthMet) {
        <span><i class="pi pi-check"></i></span>
      }contains at least 8 characters</li>
      <li>@if (!upperLettersMet) {
        <span><i class="pi pi-times"></i></span>
        }@if (upperLettersMet) {
        <span><i class="pi pi-check"></i></span>
      }contains an upper case letter</li>
      <li>@if (!lowerLettersMet) {
        <span><i class="pi pi-times"></i></span>
        }@if (lowerLettersMet) {
        <span><i class="pi pi-check"></i></span>
      }contains a lower case letter</li>
      <li>@if (!numbersMet) {
        <span><i class="pi pi-times"></i></span>
        }@if (numbersMet) {
        <span><i class="pi pi-check"></i></span>
      }contains a number</li>
      <li>@if (!symbolsMet) {
        <span><i class="pi pi-times"></i></span>
        }@if (symbolsMet) {
        <span><i class="pi pi-check"></i></span>
      }contains a symbol</li>
    </ul>
  }
</div>